/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Billing_No_InvoicesInputs */



/**
* | output |
* | --- |
* | "No invoices yet." |
*
* @param {Sub_Billing_No_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_billing_no_invoices = /** @type {((inputs?: Sub_Billing_No_InvoicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Billing_No_InvoicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Rechnungen vorhanden.")
	return /** @type {LocalizedString} */ ("No invoices yet.")
});